import { apiToken, sessionApiUrl } from "../config";

// create session api  start
export const createSession = async (payload) => {
    try {
        const response = await fetch(sessionApiUrl, {
            method: 'POST',
            headers: {
                'Content-Type' : 'application/json',
                 Authorization: `Bearer ${apiToken}`
            },
            body: JSON.stringify(payload)
        });
        const res = await response.json();
        if (!response.ok) {
            throw new Error(res.message || 'Failed to fetch the data');
        }
        return res;
    } catch(e) {
        throw new Error(e.message || "Something went wrong");
    }
}

// create session end

// get all sessionn  start

export const getAllSession = async (params = {}) => {
    try {
        const url = new URL(sessionApiUrl);
        const query = {
            page: params.page || 1,
            limit: params.limit || 20,
            name: params.name,
            assistantId: params.assistantId,
            workflowId: params.workflowId,
            sortOrder: params.sortOrder,
            createdAtGt: params.createdAtGt,
            createdAtLt: params.createdAtLt,
            createdAtGe: params.createdAtGe,
            createdAtLe: params.createdAtLe,
            updatedAtGt: params.updatedAtGt,
            updatedAtLt: params.updatedAtLt,
            updatedAtGe: params.updatedAtGe,
            updatedAtLe: params.updatedAtLe,
          };
          Object.keys(query).forEach((key) => {
            if (query[key]) url.searchParams.append(key, query[key]);
          });
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${apiToken}`
            }
        })
        const res = await response.json();

        if (!response.ok) {
            throw new Error(res.message || " Failed to fetch the data")
        }
        return  res;
    } catch(e) {
        throw new Error(e.message || "Something went wrong");
    }
}

// get all session end